import Api from '@/services/Api'

const HEADERURL = 'inv/ent_compra/';
const ACCION_AGREGAR_DETALLE = 'agregar_detalle';
const ACCION_MODIFICAR_DETALLE = 'modificar_detalle';
const ACCION_ELIMINAR_DETALLE = 'eliminar_detalle';
const ACCION_CERRAR = 'cerrar';
const ACCION_ANULAR = 'anular';
const ACCION_ABRIR = 'abrir';
const ACCION_IMPRIMIR_BARRA = 'imprimir_barra';
const ACCION_IMPRIMIR_HABLADOR = 'imprimir_hablador';
const ACCION_IMPRIMIR_PDF = 'pdf';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    agregar_detalle(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_AGREGAR_DETALLE}/`, params);

    },

    eliminarDetalle(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACCION_ELIMINAR_DETALLE}/`, params);

    },

    editarDetalle(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACCION_MODIFICAR_DETALLE}/`, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACCION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACCION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACCION_ANULAR}/`);

    },

    imprimir_barra(id) {

        return Api().post(`${HEADERURL}${id}/${ACCION_IMPRIMIR_BARRA}/`);

    },

    imprimir_hablador(id) {

        return Api().post(`${HEADERURL}${id}/${ACCION_IMPRIMIR_HABLADOR}/`);

    },

    pdf(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACCION_IMPRIMIR_PDF}/`, params);

    },

}